import React from "react";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import CircularProgress from "@mui/material/CircularProgress";
import { Add, Close, Done } from "@mui/icons-material";
import { ActividadContext } from "../Context/ActividadContext";
import NuevaActividad from "./NuevaActividad/index";
import { isMobile } from "../../../../Config/constantes";

export default function AddNewItem() {
  const {
    initial_actividad,
    setNewItem,
    newItem,
    loadingSave,
    mode,
  } = React.useContext(ActividadContext);

  const handleRemove = () => {
    setNewItem(null);
  };

  React.useEffect(() => {
    window.addEventListener("keydown", KeyDownFunction);
    function KeyDownFunction(e) {
      const tecla_escape = e.keyCode;
      if (tecla_escape === 27 && mode !== "calendar") {
        if (!newItem) {
          setNewItem(initial_actividad);
        } else {
          setNewItem(null);
        }
      }
    }
    return () => window.removeEventListener("keydown", KeyDownFunction);
  }, [newItem, initial_actividad, setNewItem, mode]);

  return !newItem ? (
    mode === "calendar" ? (
      <NuevaActividad />
    ) : (
      <Button
        color="primary"
        size="small"
        variant="contained"
        startIcon={isMobile ? null : <Add />}
        disableElevation
        onClick={() => setNewItem(initial_actividad)}
        sx={{ textTransform: "none", minWidth: 40 }}
      >
        {isMobile ? <Add fontSize="small" /> : "Nuevo"}
      </Button>
    )
  ) : (
    <ButtonGroup
      variant="contained"
      color="primary"
      size="small"
      disableElevation
    >
      <Button
        color="primary"
        size="small"
        variant="contained"
        startIcon={
          loadingSave ? (
            <CircularProgress color="inherit" size={20} />
          ) : (
            <Done />
          )
        }
        disableElevation
        form="form-actividad-table"
        type="submit"
        sx={{ textTransform: "none" }}
      >
        Guardar
      </Button>
      <Button
        size="small"
        onClick={handleRemove}
        sx={{ minWidth: "35px!important", padding: 0 }}
      >
        <Close sx={{ fontSize: 16 }} />
      </Button>
    </ButtonGroup>
  );
}
